import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number: string | number) {
  return numeral(number).format(Number.isInteger(number) ? '0,0' : '0,0.00');
}

export function fCurrencyExtended(number: string | number) {
  return numeral(number).format(
    Number.isInteger(number) ? '0,0' : '0,0.00[00]'
  );
}

export function fCurrencyUSD(number: string | number) {
  const formattedNumber = number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'USD',
  });

  return formattedNumber;
}

export function fCurrencyUSDExtended(number: string | number): string {
  const formattedNumber = number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
    style: 'currency',
    currency: 'USD',
  });

  return formattedNumber;
}

export function fCurrencyUSDUnlimited(number: string | number) {
  const formattedNumber = number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    style: 'currency',
    currency: 'USD',
  });

  return formattedNumber;
}

export function fPercent(number: number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number: string | number) {
  return numeral(number).format();
}

export function fShortenNumber(number: string | number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number: string | number) {
  return numeral(number).format('0.0 b');
}

export function formatFileSize(bytes: number): string {
  const GB = 1024 * 1024 * 1024;
  const MB = 1024 * 1024;
  const KB = 1024;

  if (bytes >= GB) {
    return `${(bytes / GB).toFixed(2)} gb`;
  } else if (bytes >= MB) {
    return `${(bytes / MB).toFixed(2)} mb`;
  }
  return `${(bytes / KB).toFixed(2)} kb`;
}
